export const getCssVar = (name) =>
  getComputedStyle(document.documentElement).getPropertyValue(name).trim();

export const getCssVars = (names) =>
  names.reduce((acc, name) => {
    acc[name] = getCssVar(name);
    return acc;
  }, {});
